/*
 * Custom glazing rule, made for Valge entrance doors
 */
class GlassRulesService {
    constructor() {
        this.laminated33SafetyType = 3;
        this.laminated44SafetyType = 4;
    }

    areConditionsMet(insideGlass, outsideGlass) {
        return this.isLaminated44SafetyTypeOneSideAndOtherLaminatedSafetyTypeOtherSide(insideGlass, outsideGlass);
    }

    hideOutsideGlass(outsideGlass, selectedInsideGlass) {
        return this.isLaminated44SafetyTypeOneSideAndOtherLaminatedSafetyTypeOtherSide(selectedInsideGlass, outsideGlass);
    }

    hideInsideGlass(insideGlass, selectedOutsideGlass) {
        return this.isLaminated44SafetyTypeOneSideAndOtherLaminatedSafetyTypeOtherSide(insideGlass, selectedOutsideGlass);
    }

    isLaminated44SafetyTypeOneSideAndOtherLaminatedSafetyTypeOtherSide(insideGlass, outsideGlass) {
        return (insideGlass.attributes.glassSafetyId === this.laminated33SafetyType && outsideGlass.attributes.glassSafetyId === this.laminated44SafetyType) ||
            (insideGlass.attributes.glassSafetyId === this.laminated44SafetyType && outsideGlass.attributes.glassSafetyId === this.laminated33SafetyType);
    }
}

export default angular.module('glassRulesService', [])
    .service('glassRulesService', GlassRulesService)
    .name;
